import { createListenerMiddleware, addListener } from '@reduxjs/toolkit'
import { AppDispatch, RootState } from '@/app/store';
import { activeCommentSet } from '@/store/slices/commentSlice';
import axios from 'axios';

export const listenerMiddleware = createListenerMiddleware();

export const startAppListening = listenerMiddleware.startListening.withTypes<
    RootState,
    AppDispatch
>()

export const addAppListener = addListener.withTypes<RootState, AppDispatch>();

startAppListening({
    actionCreator: activeCommentSet,
    effect: async (action, listenerApi) => {
        listenerApi.cancelActiveListeners();
        await listenerApi.delay(1000);
        if (action.payload && listenerApi.getState().user.role == "customer") {
            const commentId = action.payload.id;
            axios.post(`https://api.getspect.ai/v3/comment/${commentId}/active`, {}, { withCredentials: true })
        }
    }
});
